<template>
  <div>
    <Mainlayout></Mainlayout>

    <CCard class="custom-card h-100 mt-5">
      <br /><br /><br /><br />
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12" class="custom-margin">
              <h5
                class="text-left mt-5 d-flex d-sm-none text-black bold"
                style="font-size: 18px"
              >
                Question 1.
                Farid has been _____ his parent to buy him a new bike for months.
              </h5>
              
              <p style="margin-bottom: 0px" v-if="choiceA != ''">
                A. {{choiceA}} 
              </p>
              <p style="margin-bottom: 0px" v-if="choiceB != ''">
                B. {{choiceB}} 
              </p>
              <p style="margin-bottom: 0px" v-if="choiceC != ''">
                C. {{choiceC}} 
              </p>
              <p style="margin-bottom: 0px" v-if="choiceD != ''">
                D. {{choiceD}} 
              </p>
              <p style="margin-bottom: 0px" v-if="choiceE != ''">
                E. {{choiceE}}
              </p>
              <p style="margin-bottom: 0px" v-if="choiceF != ''">
                F. {{choiceF}}
              </p>
              <p style="margin-bottom: 0px" v-if="choiceG != ''">
                G. {{choiceG}}
              </p>
              

              <!-- {{ questionDetail.questionNo }}.
                {{ questionDetail.questionName }}
              </h5>
              <div class="mt-4">
                (A) {{ questionDetail.choiceA }} <br /><br />
                (B) {{ questionDetail.choiceB }} <br /><br />
                (C) {{ questionDetail.choiceC }} <br /><br />
                (D) {{ questionDetail.choiceD }} <br /><br />
              </div> -->

              <CRow>
                <div
                  class="mx-auto d-flex justify-content-center col-12 ml-4 mt-1"
                >
                  <div class="text-center custom-width-lg">
                    <CRow class="justify-content-center">
                      <CCol sm="12" lg="12" class="mt-4" style="display: flex">
                        <span sm="6" lg="6" style="flex: 2" v-if="choiceA != ''">
                          <form>
                            <CBadge
                              shape="pill"
                              color="danger"
                              class="custom-pill box-shadow"
                            >
                              <input type="radio" v-model="answer" value="1" />
                              <span
                                style="text-align: center; width: 90%"
                                class="custom-label"
                                >A
                              </span>
                            </CBadge>
                          </form>
                        </span>
                        <span sm="6" lg="6" style="flex: 2" v-if="choiceB != ''">
                          <CBadge
                            shape="pill"
                            color="success"
                            class="custom-pill box-shadow"
                          >
                            <input
                              type="radio"
                              v-model="answer"
                              value="2"
                            /><span
                              style="text-align: center; width: 90%"
                              class="custom-label"
                            >
                              B
                            </span>
                          </CBadge>
                        </span>
                        <br />
                      </CCol>
                      <CCol sm="12" lg="12" class="mt-4" style="display: flex">
                        <span sm="6" lg="6" style="flex: 2" v-if="choiceC != ''">
                          <CBadge
                            shape="pill"
                            color="danger"
                            class="custom-pill box-shadow"
                          >
                            <input
                              type="radio"
                              v-model="answer"
                              value="3"
                            /><span
                              style="text-align: center; width: 90%"
                              class="custom-label"
                            >
                              C
                            </span>
                          </CBadge>
                        </span>
                        <span sm="6" lg="6" style="flex: 2" v-if="choiceD != ''">
                          <CBadge
                            shape="pill"
                            color="danger"
                            class="custom-pill box-shadow"
                          >
                            <input
                              type="radio"
                              v-model="answer"
                              value="4"
                            /><span
                              style="text-align: center; width: 90%"
                              class="custom-label"
                            >
                              D
                            </span>
                          </CBadge>
                        </span>
                      </CCol>
                      <CCol sm="12" lg="12" class="mt-4" style="display: flex" v-if="choiceE != ''">
                        <span sm="6" lg="6" style="flex: 2" v-if="choiceE != ''">
                          <form>
                            <CBadge
                              shape="pill"
                              color="danger"
                              class="custom-pill box-shadow"
                            >
                              <input type="radio" v-model="answer" value="1" />
                              <span
                                style="text-align: center; width: 90%"
                                class="custom-label"
                                >E
                              </span>
                            </CBadge>
                          </form>
                        </span>
                        <span sm="6" lg="6" style="flex: 2" v-if="choiceF != ''">
                          <CBadge
                            shape="pill"
                            color="danger"
                            class="custom-pill box-shadow"
                          >
                            <input
                              type="radio"
                              v-model="answer"
                              value="2"
                            /><span
                              style="text-align: center; width: 90%"
                              class="custom-label"
                            >
                              F
                            </span>
                          </CBadge>
                        </span>
                        <br />
                      </CCol>
                      <CCol sm="6" lg="6" class="mt-4" style="display: flex" v-if="choiceG != ''">
                        <span sm="6" lg="6" style="flex: 2">
                          <form>
                            <CBadge
                              shape="pill"
                              color="danger"
                              class="custom-pill box-shadow"
                            >
                              <input type="radio" v-model="answer" value="1" />
                              <span
                                style="text-align: center; width: 90%"
                                class="custom-label"
                                >G
                              </span>
                            </CBadge>
                          </form>
                        </span>
                        
                        <br />
                      </CCol>

                      <CCol sm="12" class="text-left mt-5">
                        <div><h3>Explanation</h3></div>
                        <br />

                        <div><h4>Answer : B</h4></div>
                        <p>
                          It is sufficient to come up with onw counterexample to
                          show the statement/implication is false. This
                          statement is false since 2 is even and 2 is a prime
                          number.
                        </p>
                      </CCol>

                      <CCol sm="12" class="text-right">
                        <CButton
                          color="primary"
                          class="mt-4 mb-4 float-right"
                          size="lg"
                          @click="SubmitAnswer"
                          >Next
                          <div>
                            <CIcon name="cil-arrow-right" />
                          </div>
                        </CButton>
                      </CCol>
                    </CRow>
                  </div>
                </div>
              </CRow>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import Mainlayout from "../containers/TheHeaderWebStudent.vue";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
    Mainlayout
  },
  data() {
    return {
      backgroundBanner,
      //questionDetail: {},
      SubmittedForm: false,
      answer: "",
      Error: false,
      choiceA: "forcing",
      choiceB: "persuading",
      choiceC: "begging",
      choiceD: "yelling",
      choiceE: "",
      choiceF: "",
      choiceG: "",
    };
  },
   async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetQuestion();
    } else {
      this.GoToLogin();
    }
  },
  computed: {
  },
  methods: {
    GoToRefresh() {
      window.location.reload();
    },
    GoToPageScore() {
      this.$router.push(
        "/QuizStudentDashboard?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    }
  }
};
</script>
